import Flex from "@/components/flex"
import { TrendingUp, TrendingDown } from "lucide-react"
import { langStore } from "@/stores/lang-store"
import AnimatedNumber from "./animated-number"
import { kpiMetricBundle } from "./kpi-metric-const"
import Wrapper from "@/components/wrapper"

const KpiMetricCard = ({ item, period }) => {
  const { lang } = langStore()

  return (
    <Wrapper.shadow className="p-5 flex flex-col gap-4 bg-white rounded-2xl min-h-30">
      <Flex className="justify-between items-start">
        <Flex className="flex-col" gap={4}>
          <p className="text-sm text-gray-500 font-medium">{item.label[lang]}</p>

          <h2 className="text-2xl font-bold text-gray-800 flex items-end gap-1">
            <AnimatedNumber value={item.value} decimals={1} />
            <span className="text-sm text-gray-500 mb-1">{item.unit}</span>
          </h2>
        </Flex>

        <Flex
          className={`
            w-12 h-12 rounded-xl
            items-center justify-center
            ${item.iconBg}
          `}
        >
          <img src={item.imgSrc} alt={item.label} className="w-7 h-7 object-contain" />
        </Flex>
      </Flex>

      <div className="flex items-end gap-2 text-sm">
        {item.isUp ? (
          <TrendingUp className="w-4 h-4 text-red-500" />
        ) : (
          <TrendingDown className="w-4 h-4 text-blue-500" />
        )}
        <span className={`font-semibold ${item.isUp ? "text-red-500" : "text-blue-500"}`}>
          {item.diff}
        </span>
        <span className="text-gray-400 text-xs">{kpiMetricBundle[period][lang]}</span>
      </div>
    </Wrapper.shadow>
  )
}

export default KpiMetricCard
